var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "calendar",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#8754ba",
    opacity: 0.003
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    d: "M695.7 258.168h9.7a.626.626 0 0 0 0-1.251h-9.7a.626.626 0 0 0 0 1.251z",
    className: "cls-2",
    transform: "translate(-681.972 -236.837)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    d: "M701.507 281.541h-5.8a.626.626 0 0 0 0 1.251h5.8a.626.626 0 1 0 0-1.251z",
    className: "cls-2",
    transform: "translate(-681.972 -257.395)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    d: "M686.558 193.461v-10.809a3.129 3.129 0 0 0-3.128-3.128h-2.565v-1.194a.626.626 0 0 0-1.251 0v1.195h-8.508v-1.195a.625.625 0 1 0-1.251 0v1.195h-2.565a3.129 3.129 0 0 0-3.128 3.128V199.6a3.129 3.129 0 0 0 3.128 3.128h11.58a6.882 6.882 0 1 0 7.688-9.265zM667.3 180.776h2.565v1.195a.625.625 0 1 0 1.251 0v-1.195h8.508v1.195a.626.626 0 1 0 1.251 0v-1.195h2.565a1.882 1.882 0 0 1 1.877 1.877v1.514h-19.896v-1.514a1.878 1.878 0 0 1 1.879-1.877zm0 20.7a1.882 1.882 0 0 1-1.877-1.877v-14.188h19.886v7.932h-.019a6.892 6.892 0 0 0-6.768 8.132zm17.991 4.379a5.63 5.63 0 1 1 5.63-5.63 5.63 5.63 0 0 1-5.633 5.629z",
    className: "cls-2",
    transform: "translate(-656.163 -170.704)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    d: "M775.755 299.6l-3.716 3.547-1.921-1.927a.624.624 0 1 0-.882.882l2.358 2.358a.615.615 0 0 0 .444.181.6.6 0 0 0 .431-.175l4.154-3.972a.622.622 0 0 0 .019-.882.636.636 0 0 0-.887-.012z",
    className: "cls-2",
    transform: "translate(-743.734 -272.327)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.012fcb2b.svg";
export { ForwardRef as ReactComponent };